import React from 'react';
import { AppFactory } from '@app/app-factory';
import { styled } from '@naan/stitches.config';
import __ from 'core/lib/localization';

const Wrapper = styled('div', {
  font: 'var(--body-font)',
  textAlign: 'center',
  color: 'var(--red)',
  marginTop: '56px',
  padding: '8px 12px',
  border: '1px solid var(--pink)',
  breakInside: 'avoid-page',

  '& .learn-more a': {
    color: 'var(--text-secondary)',
  },
});

export const StoryGuideLicense = ({ learnMore = false }) => {
  const { userManager } = AppFactory.root;
  const { email } = userManager?.accountData ?? {};
  return (
    <Wrapper>
      {__(
        'This guide is licensed to %{email} for use with the Lupa app in a classroom setting',
        'storyGuide.license',
        { email }
      )}
      {learnMore ? (
        <div className="learn-more">
          Learn about Lupa for Schools at{' '}
          <a href="https://www.lupa.app/schools">lupa.app/schools</a>
        </div>
      ) : null}
    </Wrapper>
  );
};
